import { Box, Card, CardContent, Typography, Divider } from '@mui/material'
import { useTranslator } from '@/hooks'

export const StatisticSummaryCards = ({ dataCompare }: { dataCompare: any }) => {
  const { __, __n } = useTranslator()

  return (
    <div className='flex flex-col gap-[26px]'>
      <Card className='rounded-[16px]'>
        <CardContent className='p-0 '>
          <div className='flex flex-col gap-6 p-6 '>
            <div className='flex flex-col gap-2'>
              <div className='flex flex-row gap-3 items-center'>
                <Box className='p-2 rounded-[6px] bg-[#DFE6E8] flex items-center justify-center'>
                  <i className='tabler-receipt-tax text-[#346272]'></i>
                </Box>
                <Typography className='text-[24px] font-normal leading-[38px]'>
                  {__n(dataCompare?.voucher?.voucher_no_tax, 'đ')}
                </Typography>
              </div>
              <Typography className='text-[15px] font-medium leading-[22px]'>{__('Voucher')}</Typography>
              <div className='flex flex-row gap-1 items-center'>
                <Typography className='text-[15px] font-medium leading-[22px]'>
                  {__n(
                    ((dataCompare?.voucher?.voucher_no_tax - dataCompare?.voucher?.voucher_no_tax_last_month) /
                      dataCompare?.voucher?.voucher_no_tax_last_month) *
                      100
                  )}
                  %
                </Typography>
                <Typography className='text-[13px] font-normal leading-[20px] text-[#999]'>
                  {__('compared to last Month')}
                </Typography>
              </div>
            </div>
            <Divider />

            <div className='flex flex-col gap-2'>
              <div className='flex flex-row gap-3 items-center'>
                <Box className='p-2 rounded-[6px] bg-[#DFE6E8] flex items-center justify-center'>
                  <i className='tabler-briefcase text-[#346272]'></i>
                </Box>
                <Typography className='text-[24px] font-normal leading-[38px]'>
                  {__n(dataCompare?.voucher?.voucher_tax, 'đ')}
                </Typography>
              </div>
              <Typography className='text-[15px] font-medium leading-[22px]'>{__('Fee Tax')}</Typography>
              <div className='flex flex-row gap-1 items-center'>
                <Typography className='text-[15px] font-medium leading-[22px]'>
                  {__n(
                    ((dataCompare?.voucher?.voucher_tax - dataCompare?.voucher?.voucher_tax_last_month) /
                      dataCompare?.voucher?.voucher_tax_last_month) *
                      100
                  )}
                  %
                </Typography>
                <Typography className='text-[13px] font-normal leading-[20px] text-[#999]'>
                  {__('compared to last Month')}
                </Typography>
              </div>
            </div>
          </div>
        </CardContent>
      </Card>
      <Card className='rounded-[16px]'>
        <CardContent className='p-0 '>
          <div className='flex flex-col gap-6 p-6 '>
            <div className='flex flex-col gap-2'>
              <div className='flex flex-row gap-3 items-center'>
                <Box className='p-2 rounded-[6px] bg-[#DFE6E8] flex items-center justify-center'>
                  <i className='tabler-gift text-[#346272]'></i>
                </Box>
                <Typography className='text-[24px] font-normal leading-[38px]'>
                  {__n(dataCompare?.services_fee?.services_fee_no_tax, 'đ')}
                </Typography>
              </div>
              <Typography className='text-[15px] font-medium leading-[22px]'>{__('Services Fee')}</Typography>
              <div className='flex flex-row gap-1 items-center'>
                <Typography className='text-[15px] font-medium leading-[22px]'>
                  {__n(
                    ((dataCompare?.services_fee?.services_fee_no_tax -
                      dataCompare?.services_fee?.services_fee_no_tax_last_month) /
                      dataCompare?.services_fee?.services_fee_no_tax_last_month) *
                      100
                  )}
                  %
                </Typography>
                <Typography className='text-[13px] font-normal leading-[20px] text-[#999]'>
                  {__('compared to last Month')}
                </Typography>
              </div>
            </div>

            <Divider />

            <div className='flex flex-col gap-2'>
              <div className='flex flex-row gap-3 items-center'>
                <Box className='p-2 rounded-[6px] bg-[#DFE6E8] flex items-center justify-center'>
                  <i className='tabler-briefcase text-[#346272]'></i>
                </Box>
                <Typography className='text-[24px] font-normal leading-[38px]'>
                  {__n(dataCompare?.services_fee?.services_fee_tax, 'đ')}
                </Typography>
              </div>
              <Typography className='text-[15px] font-medium leading-[22px]'>
                {__(`Services Fee Tax AVG ${Number(dataCompare?.services_fee?.vat_rate ?? 0).toFixed(2)}%`)}
              </Typography>
              <div className='flex flex-row gap-1 items-center'>
                <Typography className='text-[15px] font-medium leading-[22px]'>
                  {__n(
                    ((dataCompare?.services_fee?.services_fee_tax -
                      dataCompare?.services_fee?.services_fee_tax_last_month) /
                      dataCompare?.services_fee?.services_fee_tax_last_month) *
                      100
                  )}
                  %
                </Typography>
                <Typography className='text-[13px] font-normal leading-[20px] text-[#999]'>
                  {__('compared to last Month')}
                </Typography>
              </div>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  )
}
